import React, { FC } from 'react'
import styled from 'styled-components'

import CheckIcon from '@Assets/SVG/Check'
import StarBgIcon from '@Assets/SVG/StarBg'
import { SVGIcon } from '@Components/Icons'
import { ContentProps } from '@Components/Modal/Dialog'
import { box, flexCenterChildren, flexCenterChildrenColumn } from '@Globals/Style/mixins'

const Wrapper = styled.div`
  ${flexCenterChildrenColumn};
  padding-top: 30px;
`

const StackedIcons = styled.div`
  position: relative;
  ${box({ width: '100px' })}
`

const Icon = styled.div`
  position: absolute;
`

const ForegroundIcon = styled(Icon)`
  ${flexCenterChildren};
  ${box({ width: '100%' })}
`

const Title = styled.h2`
  font-size: 1.5rem;
  text-transform: none;
  color: ${({ theme }) => theme.colors.greyDark}
`

const Text = styled.p`
  color: ${({ theme }) => theme.colors.grey};
  padding: 0;
`

type SuccessContentProps = Omit<ContentProps, 'variant'>

export const SuccessContent: FC<SuccessContentProps> = ({
  children,
  title,
}: SuccessContentProps) => (
  <Wrapper>
    <StackedIcons>
      <Icon>
        <SVGIcon color="white" icon={StarBgIcon} size="100px" strokeColor="primary" strokeWidth="10px" />
      </Icon>
      <ForegroundIcon>
        <SVGIcon color="primary" icon={CheckIcon} size="50px" />
      </ForegroundIcon>
    </StackedIcons>
    <Title>{title}</Title>
    <Text>{children}</Text>
  </Wrapper>
)
